// libs
import { Record, List } from "immutable";
import MenuItem from "./MenuItem";


const BaseRecord = Record({
  name: null, // string
  items: List(), // List<MenuItem>
  note: List()
});

export default class Menu extends BaseRecord {
  init(data) {
    // console.log(data);
    let notes = List();
    let items = List();

    if (data.note) {
      data.note.forEach((note) => {
        notes = notes.push(note.item);
      });
    }

    items = data.items.map(item => new MenuItem().init(item));

    return this.withMutations(s =>
      s.set("name", data.name)
       .set("note", notes)
       .set("items", items)
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/models/MenuCategory.js